"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavMenuItem = require("../NavMenuItem.styled");

var _ = require("../../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SubMenuItem = function SubMenuItem(props) {
  var href = props.href,
      to = props.to,
      children = props.children;
  return _react.default.createElement(_NavMenuItem.PopoverMenuLink, {
    tertiary: true,
    href: href,
    to: to
  }, _react.default.createElement(_.Text, null, children));
};

exports.SubMenuItem = SubMenuItem;
SubMenuItem.defaultProps = {
  href: undefined
};
SubMenuItem.propTypes = {
  href: _propTypes.default.string
};